import { render, staticRenderFns } from "./bimTextH5.vue?vue&type=template&id=4a4f2161&scoped=true&lang=html&"
import script from "./bimTextH5.vue?vue&type=script&lang=js&"
export * from "./bimTextH5.vue?vue&type=script&lang=js&"
import style0 from "./bimTextH5.vue?vue&type=style&index=0&id=4a4f2161&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f2161",
  null
  
)

export default component.exports